/**
 * @license
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://raw.githubusercontent.com/l-lin/angular-datatables/master/LICENSE
 */

/**
 * @module
 * @description
 * Entry point from which you should import all public library APIs.
 */
export { DataTableDirective } from './src/angular-datatables.directive';
export { DataTablesModule } from './src/angular-datatables.module';
